import React, { useState } from 'react'
import { TargetTitle } from 'src/components/Global/Text/TitleText'
import { ModalButton } from 'src/components/Global/Button/Button'
import { DatePicker } from 'src/components/Global/Date/Date'
import { Link, useLocation } from 'react-router-dom'
import { FormContainer, CreateCollaboWrapper } from './styles'
import { CollaboTypes } from 'src/redux/types/collaboTypes'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'

const CreateCollaboFour = () => {
  let location = useLocation()
  const [collaboData, setCollaboData] = useState({
    start_date: '',
    end_date: '',
  })
  const { start_date, end_date } = collaboData
  const dispatch = useDispatch()
  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...collaboData }
    newData[name] = value
    setCollaboData(newData)
    dispatch(action(CollaboTypes.COLLABO_FORM_DATA, newData))
  }
  return (
    <FormContainer>
      <CreateCollaboWrapper>
        <div className="top-content">
          <TargetTitle className="targetTitle">Create Collabo</TargetTitle>
          <div className="input">
            <h4>When will it start?</h4>
            <DatePicker
              type="date"
              value={start_date}
              onChange={handleChange}
              name="start_date"
              placeholder="Start Date"
            />
          </div>

          <div className="input">
            <h4>When will it end?</h4>
            <DatePicker
              type="date"
              value={end_date}
              onChange={handleChange}
              name="end_date"
              placeholder="End Date"
            />
          </div>
        </div>
        <div className="top">
          <Link
            to={`/add-collaborator`}
            state={{ backgroundLocation: location }}
          >
            <ModalButton className="targets">Continue</ModalButton>
          </Link>
        </div>
      </CreateCollaboWrapper>
    </FormContainer>
  )
}
export { CreateCollaboFour }
